import { render, staticRenderFns } from "./loginCallbackThirdInfo.vue?vue&type=template&id=6b3f59d2&"
import script from "./loginCallbackThirdInfo.vue?vue&type=script&lang=js&"
export * from "./loginCallbackThirdInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports